const CHANNEL_FUNNEL_2_1 = 'new.funnel.2_1';
const CHANNEL_FUNNEL_2_0 = 'new.funnel.2_0';
const CHANNEL_FUNNEL_3_1 = 'uranus.new.funnel.3_1';
const CHANNEL_FUNNEL_3_2 = 'uranus.new.funnel.3_2';
const CHANNEL_FUNNEL_4_0 = 'new.funnel.4_0';

export default {
  props: {
    experiment: {
      type: String,
      required: false,
    },
  },

  computed: {
    isFunnelExperiment_v2_1() {
      return this.experiment === CHANNEL_FUNNEL_2_1;
    },
    isFunnelExperiment_v2_0() {
      return this.experiment === CHANNEL_FUNNEL_2_0;
    },
    isFunnelExperiment_v3_1() {
      return this.experiment === CHANNEL_FUNNEL_3_1;
    },
    isFunnelExperiment_v3_2() {
      return this.experiment === CHANNEL_FUNNEL_3_2;
    },
    isFunnelExperiment_v4_0() {
      return this.experiment === CHANNEL_FUNNEL_4_0;
    },
    experimentQuery() {
      if (this.isFunnelExperiment_v2_1) {
        return '?version=2_1';
      } else if (this.isFunnelExperiment_v2_0) {
        return '?version=2_0';
      } else if (this.isFunnelExperiment_v3_1) {
        return '?version=3_1';
      } else if (this.isFunnelExperiment_v3_2) {
        return '?version=3_2';
      } else if (this.isFunnelExperiment_v4_0) {
        return '?version=4_0';
      }
      return '';
    },
    getExperimentVersion() {
      return this.experiment?.split('.').pop();
    },
  },
};
